/**
 * SuperballBingoStyle2 sections — Modern Casino / Neon theme.
 * Dark gray-950 with amber/purple glow overlays, neon border, gradient badge.
 */
import React from 'react'
import Zap from 'lucide-react/dist/esm/icons/zap.js';
import InlineTranslationEdit from '../../../components/InlineTranslationEdit'
import HeroPartnerGlassSelect from '../../../components/HeroPartnerGlassSelect'
import BingoBall from '../../../components/BingoBall'
import { useContent } from '../../../contexts/ContentContext'

/**
 * Hero section — dark neon casino aesthetic with glow overlays.
 */
export function BingoStyle2HeroSection({ editMode, handleTranslationUpdate }) {
  const { c } = useContent()

  return (
    <>
      {/* Neon glow background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-500/20 rounded-full blur-[100px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-amber-500/20 to-purple-500/20 border border-amber-500/30 rounded-full text-amber-400 text-sm font-bold uppercase tracking-wider mb-6 backdrop-blur-sm">
          <Zap className="w-4 h-4" />
          <InlineTranslationEdit
            translationKey="superballBingo.liveSession"
            value={c('superballBingo.liveSession', 'Live Session')}
            fallback="Live Session"
            onUpdate={handleTranslationUpdate}
            editMode={editMode}
          />
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-4">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 animate-pulse">
            <InlineTranslationEdit
              translationKey="superballBingo.superballLabel"
              value={c('superballBingo.superballLabel', 'SUPERBALL')}
              fallback="SUPERBALL"
              onUpdate={handleTranslationUpdate}
              editMode={editMode}
            />
          </span>
          <br />
          <span className="text-white">
            <InlineTranslationEdit
              translationKey="superballBingo.bingoLabel"
              value={c('superballBingo.bingoLabel', 'BINGO')}
              fallback="BINGO"
              onUpdate={handleTranslationUpdate}
              editMode={editMode}
            />
          </span>
        </h1>

        <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10">
          <InlineTranslationEdit
            translationKey="superballBingo.subtitle"
            value={c(
              'superballBingo.subtitle',
              '75 balls. One hides the golden Superball. Pick wisely and win big.'
            )}
            fallback="75 balls. One hides the golden Superball. Pick wisely and win big."
            onUpdate={handleTranslationUpdate}
            editMode={editMode}
          />
        </p>

        <HeroPartnerGlassSelect className="mx-auto mb-10 w-full max-w-md" />

        <div className="flex justify-center gap-4">
          <BingoBall number={76} size="2xl" animated />
        </div>
      </div>
    </>
  )
}
